export const defaultProps = {
  table: [],
  columns: [],
  options: {
    size: 5,
    page: 0,
    search: '',
    order: 'asc',
    orderBy: null,
    orderTable: [],
    selected: [],
    canSelect: false,
    showAll: false,
    showSize: true,
    minSize: 5,
    tableSizes: [5, 10, 20],
    withPaging: true,
    isLoading: false,
    showFilter: false,
    filters: {},
    showRowForm: false,
    rowFormValues: {},
    parentField: '',
    treeTable: false,
    childrenField: 'children',
    rowsCount: 0,
    serverPaging: false,
    showSearch: true,
    tableLabel: '',
  },
  methods: {
    onRowClick: null,
    onPageChange: null,
    onOrderChange: null,
    onSearchChange: null,
    onFiltersChange: null,
    onPageSizeChange: null,
    onSelectAllChange: null
  },
  actions: {
    line: {},
    header: {},
    toolbar: {},
    createForm: {},
    updateForm: {},
    toolbarSelected: {},
  },
};
